import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query, SubscriptionWrapper} from 'react-apollo'
import {debounce} from 'lodash'
import {withRouter} from "react-router-dom"
import 'react-table/react-table.css'

import QUERY from '../../../queries/server/user_roles'
//import SUBSCRIPTION from '../../../queries/server/subscriptions/project_upserted'

class UserRolesList extends Component {

    componentDidMount() {
        this.props.subscribeToUpsert()
    }

    render() {
        return (<ReactTable
            data={this.props.data}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "ID",
                    id: 'id',
                    accessor: 'user_role_id',
                    maxWidth: '100',
                    filterable: false
                },
                {
                    Header: "Description",
                    id: 'description',
                    accessor: "description",
                    filterMethod: (filter, row) => {
                        if(!filter.value) return true

                        return row.description.toLowerCase().includes(filter.value.toLowerCase())
                    },
                }
            ]}
            className="-striped -highlight"
            filterable
            showPagination={true}
            pages={this.props.pages}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        console.log(rowInfo)
                        this.props.history.push(`/user_roles/${rowInfo.original.user_role_id}`)
                    }
                }
            }}
        />)
    }
}

UserRolesList = withRouter(UserRolesList)

export default class UserRolesTable extends Component {


    render() {

        return (<Query query={QUERY} fetchPolicy="no-cache">
            {(result) => {

                const data = (result.data && result.data.user_roles) ? result.data.user_roles : []

                return (
                    <UserRolesList
                        loading={result.loading}
                        data={data}
                        subscribeToUpsert={() => {
                            /*return result.subscribeToMore(
                                {
                                    document: SUBSCRIPTION,
                                    variables: {
                                        name,
                                        client_type_id,
                                    },
                                    updateQuery: (prev, {subscriptionData}) => {

                                        if (!subscriptionData.data) {
                                            return prev
                                        }

                                        let data = {}

                                        //does the record already exist using the uniqueKey
                                        const existingRecordIndex = prev.filter_clients.findIndex(data => data.client_id === subscriptionData.data.clientsUpserted.client_id)

                                        if (existingRecordIndex !== -1) {
                                            data['filter_clients'] = [
                                                ...prev.filter_clients.slice(0, existingRecordIndex),
                                                {...subscriptionData.data.clientsUpserted},
                                                ...prev.filter_clients.slice(existingRecordIndex + 1)
                                            ]
                                        }
                                        else {
                                            data['filter_clients'] = [...prev.filter_clients, subscriptionData.data.clientsUpserted]
                                        }


                                        return data
                                    }
                                }
                            )*/
                        }}/>

                )
            }}
        </Query>)
    }

}